// layouts/catalogos/formatos/services/formatos.js
import api from "services/api";

const ENDPOINT = "/format";

const unwrapList = (data) =>
  Array.isArray(data) ? data
  : Array.isArray(data?.data) ? data.data
  : Array.isArray(data?.page) ? data.page
  : Array.isArray(data?.results) ? data.results
  : [];

const unwrapOne = (data) => data?.data ?? data ?? {};

const toNumberIfPossible = (v) => {
  if (v === "" || v == null) return undefined;
  const n = Number(v);
  return Number.isFinite(n) ? n : v;
};

export async function listFormatos() {
  const { data } = await api.get(ENDPOINT);
  return unwrapList(data);
}

export async function getFormato(id) {
  const { data } = await api.get(`${ENDPOINT}/${encodeURIComponent(id)}`);
  return unwrapOne(data);
}

export async function createFormato({ name, group_id }) {
  const payload = {
    name: (name || "").trim(),
    group_id: toNumberIfPossible(group_id),
  };
  const { data } = await api.post(ENDPOINT, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return unwrapOne(data);
}

export async function updateFormato(id, { name, group_id }) {
  const payload = {
    name: (name || "").trim(),
    group_id: toNumberIfPossible(group_id),
  };
  const { data } = await api.put(`${ENDPOINT}/${encodeURIComponent(id)}`, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return unwrapOne(data);
}

export async function deleteFormato(id) {
  const { data } = await api.delete(`${ENDPOINT}/${encodeURIComponent(id)}`);
  return unwrapOne(data);
}
